module.exports = __webpack_public_path__ + "img/which-ticket-large.aa61efbe.png";